<template>
  <div v-if="article" class="artikel-wrap">
    <div class="section pt-8 d-flex flex-column align-center pb-8">
      <div class="ws-media artikel-hero">
        <v-img
          height="42vh"
          width="100%"
          cover
          :src="article.header_image"
          :alt="article.title"
        ></v-img>
      </div>

      <div class="artikel-col">
        <button class="ws-link back-link" @click="$router.push('/nieuws')">
          ← Terug naar nieuws
        </button>
        <span class="ws-eyebrow mt-4 d-block">
          {{ article.location + " · " + getDate(article.timestamp) }}
        </span>
        <h1 class="ws-h1 mt-3">{{ article.title }}</h1>
        <p class="ws-lead ws-lead--lg mt-4 artikel-sub">
          {{ article.subtitle }}
        </p>
        <div class="ws-prose mt-6" v-html="article.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import { mapState } from "vuex";
import { useMeta } from "vue-meta";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    useMeta({
      title:
        store.state.nieuws.length > 0
          ? store.state.nieuws.find((a) => a.uid === route.params.id).title
          : "Nieuwsartikel",
    });
  },
  computed: {
    ...mapState({
      nieuws: (state) => state.nieuws,
    }),
    article() {
      return this.nieuws.find((a) => a.uid === this.$route.params.id);
    },
  },
  methods: {
    getDate(d) {
      let i = DateTime.fromSeconds(d);
      return i.toLocaleString(DateTime.DATE_FULL);
    },
  },
};
</script>

<style lang="scss" scoped>
.artikel-wrap {
  margin-bottom: 120px;
}
.artikel-hero {
  width: 100%;
  margin-bottom: 40px;
}
.artikel-col {
  width: 100%;
  max-width: 720px;
}
.back-link {
  display: inline-block;
}
.artikel-sub {
  color: #5c4f44;
}
</style>
